import {
  CompanyDetail,
  CreateCompanyPayload,
  GetCompaniesPayload,
  CreateAndUpdateCompanyResponse,
  DeleteCompanyResponse,
  DeleteCompanyPayload,
  GetCompaniesResponse,
} from 'src/dto/Company';

import { baseApiWithCompanyId } from 'src/redux/services/baseApi';
import { GetCompanyFromAppKeyParams, GetCompanyFromAppKeyResponse, GetCompanyFromEmailParams, GetCompanyFromEmailResponse } from '../../dto/SuperAdmin';

export const companiesAdminApi = baseApiWithCompanyId.injectEndpoints({
  endpoints: (builder) => ({
    getCompaniesAdmin: builder.query<GetCompaniesResponse, GetCompaniesPayload>({
      query: (params) => ({
        url: 'v2/companies',
        params: {
          ...params,
          search: params.search || undefined,
        },
      }),
      providesTags: ['CompaniesAdmin'],
    }),
    getCompanyAdmin: builder.query<CompanyDetail, string>({
      query: (id) => `v2/companies/${id}`,
      providesTags: ['CompanyAdminDetail'],
    }),
    createCompanyAdmin: builder.mutation<CreateAndUpdateCompanyResponse, CreateCompanyPayload>({
      query(data) {
        return {
          url: 'v2/companies',
          method: 'POST',
          body: data,
        };
      },
      invalidatesTags: ['CompaniesAdmin', 'CompanyAdminDetail', 'Apps', 'UsersAdmin'],
    }),
    updateCompanyAdmin: builder.mutation<CreateAndUpdateCompanyResponse, CompanyDetail>({
      query(data) {
        return {
          url: 'v2/companies',
          method: 'PUT',
          body: data,
        };
      },
      invalidatesTags: ['CompaniesAdmin', 'CompanyAdminDetail'],
    }),
    deleteCompanyAdmin: builder.mutation<DeleteCompanyResponse, DeleteCompanyPayload>({
      query(data) {
        return {
          url: 'v2/companies',
          method: 'DELETE',
          body: data,
        };
      },
      invalidatesTags: ['CompaniesAdmin', 'CompanyAdminDetail'],
    }),
    getCompaniesFromEmail: builder.query<GetCompanyFromEmailResponse, GetCompanyFromEmailParams>({
      query: (params) => ({
        url: '/v2/superadmin/email_to_company',
        params: { email: params.email },
      }),
      providesTags: ['CompanyFromEmailSuperAdmin'],
    }),
    getCompaniesFromAppKey: builder.query<GetCompanyFromAppKeyResponse, GetCompanyFromAppKeyParams>({
      query: (params) => ({
        url: '/v2/superadmin/app_key_to_company',
        params: { app_key: params.app_key },
      }),
      providesTags: ['CompanyFromAppKeySuperAdmin'],
    }),
  }),
});

export const {
  useGetCompaniesAdminQuery,
  useGetCompanyAdminQuery,
  useCreateCompanyAdminMutation,
  useUpdateCompanyAdminMutation,
  useDeleteCompanyAdminMutation,
  useGetCompaniesFromEmailQuery,
  useGetCompaniesFromAppKeyQuery,
} = companiesAdminApi;
